module.exports = __webpack_public_path__ + "static/img/left-door-wall_256.8235a2c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/left-door-wall_256.png
// module id = MN2T
// module chunks = 0